// @ts-nocheck
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { useEffect, useState } from "react";

export const useHasPageLoadedWithMultipleCustomer = (customers: BillToModel[] | ShipToModel[] | undefined) => {
    const [pageHasLoadedWithMultipleCustomers, setPageHasLoadedWithMultipleCustomers] = useState(false);

    useEffect(() => {
        if (customers) {
            if (customers.length > 1) {
                setPageHasLoadedWithMultipleCustomers(true);
            }
        }
    }, [customers]);

    return pageHasLoadedWithMultipleCustomers;
};
